/* Ingredients carousel: plain flex track + native scroll-snap + scrollBy(),
   same mechanism as assets/up-bestsellers.js. No Swiper, no slick. */
(function () {
  function initCarousel(root) {
    var track = root.querySelector('[data-up-pdp-ingredients-track]');
    if (!track || track.hasAttribute('data-up-pdp-ingredients-ready')) return;
    track.setAttribute('data-up-pdp-ingredients-ready', 'true');

    var prevButtons = root.querySelectorAll('[data-up-pdp-ingredients-prev]');
    var nextButtons = root.querySelectorAll('[data-up-pdp-ingredients-next]');

    function step() {
      var card = track.querySelector('.up-pdp-ingredients__card');
      if (!card) return track.clientWidth;
      var trackStyle = getComputedStyle(track);
      var gap = parseFloat(trackStyle.columnGap || trackStyle.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function setButtonState(btn, disabled) {
      btn.disabled = disabled;
      btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      btn.classList.toggle('up-arrow--active', !disabled);
    }

    function updateArrows() {
      var trackStyle = getComputedStyle(track);
      var startPad = parseFloat(trackStyle.paddingLeft) || 0;
      var maxScroll = track.scrollWidth - track.clientWidth;
      var atStart = track.scrollLeft <= startPad + 1;
      var atEnd = maxScroll <= 1 || track.scrollLeft >= maxScroll - 1;

      prevButtons.forEach(function (btn) {
        setButtonState(btn, atStart);
      });
      nextButtons.forEach(function (btn) {
        setButtonState(btn, atEnd);
      });
    }

    prevButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    });

    nextButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
    });

    var ticking = false;
    track.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          updateArrows();
          ticking = false;
        });
      },
      { passive: true }
    );

    window.addEventListener('resize', updateArrows);
    updateArrows();
  }

  function init() {
    document.querySelectorAll('.up-pdp-ingredients').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector ? event.target.querySelector('.up-pdp-ingredients') : null;
    if (section) initCarousel(section);
  });
})();
